import { ChartOptions, Plugin } from "chart.js";

export const doughnutCenterTextPlugin = (
  text: number | string
): Plugin<"doughnut"> => ({
  id: "centerText",
  beforeDraw(chart) {
    const { ctx, width, height } = chart;
    if (!ctx) return;

    ctx.save();
    const fontSize = (height / 114).toFixed(2);
    ctx.font = `${fontSize}em sans-serif`;
    ctx.textBaseline = "middle";

    const formattedText =
      typeof text === "number" ? text.toLocaleString(navigator.language) : text;

    const textX = Math.round(
      (width - ctx.measureText(formattedText).width) / 2
    );
    const textY = height / 2;

    ctx.fillText(formattedText, textX, textY);
    ctx.restore();
  },
});

// Opzioni per il grafico doughnut
export const doughnutOptions: ChartOptions<"doughnut"> = {
  plugins: {
    tooltip: {
      callbacks: {
        label: function (tooltipItem) {
          const dataset = tooltipItem.dataset.data as number[];
          const total = dataset.reduce((acc, value) => acc + value, 0);
          const currentValue = dataset[tooltipItem.dataIndex] as number;
          const percentage = ((currentValue / total) * 100).toFixed(2);

          return `${tooltipItem.label}: ${currentValue} (${percentage}%)`;
        },
      },
    },
    legend: {
      display: false,
      position: "bottom",
      labels: {
        boxWidth: 10,
        padding: 8,
      },
    },
  },
  responsive: true,
  // maintainAspectRatio: false,
};
